export const STORY_EVENTS = {
  UGC_HOMEPAGE_ASSET: 'UGC Homepage asset',
  UGC_WRITE_NUDGE_BANNER: 'ugc_write_nudge_banner',
  STORY_ID: 'Story_id',
  SCREEN_NAME: 'ugc_stories',
};
